import React, { useRef, useState } from "react";
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormGroup,
    FormControlLabel,
    Grid,
    IconButton,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { host } from "../../data";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { countries } from "../../data";
import { isValidEmail } from '../../helpers/isValidEmail';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    textInput: {
        margin: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    clickButtons: {
        marginLeft: theme.spacing(1),
    }
}));

export default function OrgCreate(props) {
    const { t } = useTranslation();
    let history = useHistory();
    const classes = useStyles();
    const [orgName, setOrgName] = useState({ name: '' });
    const org_name = useRef("");
    const org_address_line_1 = useRef("");
    const [orgAddressLine1, setOrgAddressLine1] = useState({ address: '' });
    const org_contact = useRef("");
    const [orgContactName, setOrgContactName] = useState({ name: "" });
    const org_phone = useRef("");
    const [orgContactPhone, setOrgContactPhone] = useState({ phone: "" });
    const org_city = useRef("");
    const [orgCity, setOrgCity] = useState({ city: '' });
    const org_postal = useRef("");
    const [orgPostal, setOrgPostal] = useState({ postal: '' });
    const org_email = useRef("");
    const [orgContactEmail, setOrgContactEmail] = useState({ email: "" });
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [defCheck, setDefCheck] = useState(false);

    function isValidEnteredEmail(value) {
        if (isValidEmail(value))
            return (true);

        alert(t("youHaveEnteredAnInvalidEmail"));
        return (false);
    };

    function isValidPhoneNumber(value) {
        if ((/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''))) {
            return (true);
        }

        alert(t("youHaveEnteredAnInvalidPhone"));
        return (false);
    }

    const handleCheck = (event) => {
        setDefCheck(event.target.checked);
    };

    React.useEffect(() => {
        if (!props.orgEdit) {
            setOrgName({ name: "" });
            setOrgAddressLine1({ address: "" });
            setOrgCity({ city: "" });
            setOrgPostal({ postal: "" });
            setOrgContactEmail({ email: "" });
            setOrgContactName({ name: "" });
            setOrgContactPhone({ phone: "" });
            setCountry("");
            setRegion("");

            try {
                (async () => {
                    let user = await Auth.currentAuthenticatedUser();
                    setOrgContactEmail({ email: user.attributes.email });
                })();
            } catch (e) {
                console.log(e);
            }
        } else {
            setOrgName({ name: props.orgInfo.orgInfo.orgName });

            Auth.currentAuthenticatedUser()
                .then(response => {
                    try {
                        response.getSession((err, session) => {
                            if (err) {
                                console.log(err);
                                return;
                            }

                            console.log("Fetching org information...");

                            fetch(host + '/orgs/' + props.orgInfo.orgInfo.orgId, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': session.getIdToken().jwtToken
                                }
                            }).then(response => response.json())
                                .then(data => {
                                    setOrgAddressLine1({ address: data.address });
                                    setOrgCity({ city: data.city });
                                    setOrgPostal({ postal: data.postal });
                                    setOrgContactEmail({ email: data.contact_email });
                                    setOrgContactName({ name: data.contact_name });
                                    setOrgContactPhone({ phone: data.contact_phone });
                                    setCountry(data.country);
                                    setRegion(data.state);

                                    if (data.default_organization) {
                                        setDefCheck(true);
                                    }
                                });
                        });
                    } catch (e) {
                        console.log(e);
                    }
                })
        }
    }, [props.orgEdit]);

    const handleChangeCountry = (event) => {
        setCountry(event.target.value);
    };

    const handleChangeRegion = (event) => {
        setRegion(event.target.value);
    };

    function validateForm() {
        var ret = 1;

        if (country === "") {
            console.log("country is empty");
            alert(t("countryInvalid"));
            ret = 0;
        }

        if (region === "") {
            alert(t("stateRegionInvalid"));
            ret = 0;
        }

        if (org_name.current.value === "") {
            alert(t("nameInvalid"));
            ret = 0;
        }

        if (org_contact.current.value === "") {
            alert("Contact Invalid");
            ret = 0;
        }

        if (org_address_line_1.current.value === "") {
            alert(t("addressInvalid"));
            ret = 0;
        }

        if (org_city.current.value === "") {
            alert(t("cityInvalid"));
            ret = 0;
        }

        if (org_postal.current.value === "") {
            alert("Zip/Postal Code Invalid");
            ret = 0;
        }

        return ret;
    };

    const handleClick = async () => {
        if (isValidEnteredEmail(org_email.current.value) && isValidPhoneNumber(org_phone.current.value) && validateForm() === 1) {
            try {
                if (!props.orgEdit) {
                    let user = await Auth.currentAuthenticatedUser();
                    user.getSession((err, session) => {
                        if (err) {
                            console.log(err);
                            return;
                        }

                        const sessionToken = session.getIdToken().jwtToken;
                        var isDef = 0;
                        if (defCheck) {
                            isDef = 1;
                        }
                        var temp_org_name = org_name.current.value;
                        var body = JSON.stringify(
                            {
                                "Name": org_name.current.value,
                                "ContactName": org_contact.current.value,
                                "Email": org_email.current.value,
                                "ContactPhone": org_phone.current.value,
                                "AddressLine1": org_address_line_1.current.value,
                                "Country": country,
                                "City": org_city.current.value,
                                "State": region,
                                "PostalCode": org_postal.current.value,
                                "User": user.attributes.email,
                                "isDefault": isDef
                            }
                        );

                        var requestOptions = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': sessionToken
                            },
                            body: body
                        };

                        fetch(host + '/orgs', requestOptions)
                            .then(async response => {
                                if (!response.ok) {
                                    const rsp = await response.json();
                                    throw new Error(rsp);
                                }
                                else {
                                    props.fetchOrgInfo(temp_org_name);
                                }
                            })
                            .catch((error) => {
                                console.log(error);

                                if (error == "Error: Organization name already exists") {
                                    alert("Error: Organization name already exists");
                                }
                            });
                    });
                } else {
                    let user = await Auth.currentAuthenticatedUser();
                    user.getSession((err, session) => {
                        if (err) {
                            console.log(err);
                            return;
                        }

                        const sessionToken = session.getIdToken().jwtToken;
                        var isDef = 0;

                        if (defCheck) {
                            isDef = 1;
                        }

                        var temp_org_name = org_name.current.value;
                        var body = JSON.stringify(
                            {
                                "Name": org_name.current.value,
                                "ContactName": org_contact.current.value,
                                "Email": org_email.current.value,
                                "ContactPhone": org_phone.current.value,
                                "Address": org_address_line_1.current.value,
                                "Country": country,
                                "City": org_city.current.value,
                                "State": region,
                                "PostalCode": org_postal.current.value,
                                "User": user.attributes.email,
                                "isDefault": isDef
                            }
                        );

                        var requestOptions = {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': sessionToken
                            },
                            body: body
                        };

                        fetch(host + '/orgs/' + props.orgInfo.orgInfo.orgId, requestOptions)
                            .then(async response => {
                                return { body: await response.json(), status: response.status }
                            })
                            .then(data => {
                                console.log(data)
                                if (data.status === 200) {
                                    let url = "/";
                                    props.fetchOrgInfo(temp_org_name);
                                    history.push(url);
                                }
                                else {
                                    alert(data.body);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    });
                }
            } catch (e) {
                console.log(e);
            };
        }
    };

    return (
        <Grid
            container
            alignItems='stretch'
            direction='column'
            justify='flex-start'
            className={classes.content}>
            {!props.orgEdit
                ? <div>
                    {props.firstOrg
                        ? <Grid item xs>
                            <Box border={2} borderColor='error.main'>
                                <Typography align='center' color='error'>
                                    {t("youAreNotCurrentlyConnected")}
                                </Typography>
                            </Box>
                        </Grid>
                        : <React.Fragment>
                            <Grid item xs>
                                <Toolbar>
                                    <Tooltip title={t("goHome")}>
                                        <IconButton color='primary'
                                            component={RouterLink}
                                            to='/'>
                                            <ArrowBack />
                                        </IconButton>
                                    </Tooltip>
                                    <Typography variant='h5'
                                        color='textPrimary'>
                                        {t("back")}
                                    </Typography>
                                </Toolbar>
                            </Grid>
                            <Grid item xs><Divider /></Grid>
                            <Grid item xs>
                                <Box border={2} borderColor='error.main'>
                                    <Typography align='center' color='error'>
                                        {t("warningByCreatingANewOrg")}
                                    </Typography>
                                </Box>
                            </Grid>
                        </React.Fragment>}
                </div>
                : null
            }

            <Grid item xs>
                <form>
                    {!props.orgEdit
                        ?
                        <Typography>
                            {t("createOrganization")}
                        </Typography>
                        : <Typography>
                            {t("editOrganization")}
                        </Typography>}
                    <FormGroup>
                        <TextField id='org-name'
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                                if (regex.test(e.target.value)) {
                                    setOrgName({ name: e.target.value });
                                }
                            }}
                            value={orgName.name}
                            inputRef={org_name}
                            label={t("organizationName")}
                            variant='filled'
                            className={classes.textInput} />

                        <TextField id='org-address-line-1'
                            onChange={e => setOrgAddressLine1({ address: e.target.value })}
                            value={orgAddressLine1.address}
                            inputRef={org_address_line_1}
                            label={t("addressLine")}
                            variant='filled'
                            className={classes.textInput} />

                        <TextField id='org-city'
                            onChange={e => setOrgCity({ city: e.target.value })}
                            value={orgCity.city}
                            inputRef={org_city}
                            label={t("city")}
                            variant='filled'
                            className={classes.textInput} />

                        <TextField id='org-zip'
                            onChange={e => setOrgPostal({ postal: e.target.value })}
                            value={orgPostal.postal}
                            inputRef={org_postal}
                            label={t("zipPostalCode")}
                            variant='filled'
                            className={classes.textInput} />

                        <FormControl className={classes.formControl}>
                            <InputLabel id="country-select-label">{t("country")}</InputLabel>
                            <Select
                                labelId="country-select-label"
                                id="country-select"
                                value={country}
                                onChange={handleChangeCountry} >
                                {countries.map((country) => (
                                    <MenuItem
                                        value={country.countryName}
                                        key={country.countryShortCode}
                                    >
                                        {t(country.translationKey)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <InputLabel id="region-select-label">{t("stateRegionInvalid")}</InputLabel>
                            <Select
                                labelId="region-select-label"
                                id="region-select"
                                value={region}
                                onChange={handleChangeRegion}
                                disabled={!country} >
                                {country
                                    ? countries
                                        .find(({ countryName }) => countryName === country)
                                        .regions.map((region) => (
                                            <MenuItem value={region.name} key={region.shortCode}>
                                                {t(region.translationKey)}
                                            </MenuItem>
                                        )) : []}
                            </Select>
                        </FormControl>
                    </FormGroup>
                    <Typography>
                        {t("organizationContact")}
                    </Typography>
                    <FormGroup>
                        <TextField id='org-contact'
                            onChange={e => setOrgContactName({ name: e.target.value })}
                            value={orgContactName.name}
                            inputRef={org_contact}
                            label={t("name")}
                            variant='filled'
                            className={classes.textInput} />

                        <TextField id='org-phone'
                            onChange={e => setOrgContactPhone({ phone: e.target.value })}
                            value={orgContactPhone.phone}
                            inputRef={org_phone}
                            label={t("phoneNumber")}
                            variant='filled'
                            className={classes.textInput} />

                        <TextField id='org-email'
                            onChange={e => setOrgContactEmail({ email: e.target.value })}
                            value={orgContactEmail.email}
                            inputRef={org_email}
                            label={t("email")}
                            variant='filled'
                            className={classes.textInput} />
                        {(!props.firstOrg) && <FormControlLabel
                            control={
                                <Checkbox className={classes.clickButtons}
                                    checked={defCheck}
                                    onChange={handleCheck}
                                    name="defIndicator"
                                    color="primary"
                                />
                            }
                            label="default organization"
                        />}
                    </FormGroup>
                </form>
            </Grid>

            <Grid className={classes.clickButtons} item xs>
                <Button variant="contained" color="primary" onClick={handleClick}>
                    {t("save")}
                </Button>

                <Button color='primary' component={RouterLink} to='/'>
                    {t("cancel")}
                </Button>
            </Grid>
        </Grid>
    )
}